import React, { useState, useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { pipe, head, prop } from 'ramda';
import PropTypes from 'prop-types';

import { ID, DELETE_REASON, DELETE_COMMENT, useExaminationsActions, useAlerts } from 'store/examinations';
import QuestionContainer from 'components/QuestionContainer';
import TextArea from 'components/TextAreaNew';
import Confirm from 'components/Confirm';
import Message from 'components/Message';

import { DELETE_REASONS } from './consts';
import { Container, Wrapper, Button } from './styles';

const DeleteSection = ({ examId }) => {
  const { push } = useHistory();
  const { id: patientId } = useParams();
  const [data, setData] = useState({});
  const { removeExamination, setCurrentExamination, updateExaminations } = useExaminationsActions();
  const { action, loading, success, error } = useAlerts(removeExamination);
  const onSelect = useCallback(({ currentTarget }) => setData(($) => ({ ...$, [DELETE_REASON]: currentTarget.value })), []);
  const onChange = useCallback((v) => setData(($) => ({ ...$, [DELETE_COMMENT]: v })), []);
  const onRemove = useCallback(() => action({ [ID]: examId, ...data }), [action, data, examId]);

  useEffect(() => {
    if (success) {
      setCurrentExamination(pipe(head, prop(ID))(success));
      updateExaminations(success);
      push(`/patients/${patientId}/personal`);
      window?.scrollTo(0, 0);
    }
  }, [patientId, push, setCurrentExamination, success, updateExaminations]);

  return (
    <QuestionContainer label="Untersuch löschen">
      <Container>
        <Wrapper>
          {DELETE_REASONS.map(({ id, label }) => (
            <Button
              key={id}
              value={id}
              onClick={onSelect}
              isActive={data[DELETE_REASON] === id}
              disabled={Boolean(loading || success)}
            >
              {label}
            </Button>
          ))}
        </Wrapper>
        <TextArea value={data[DELETE_COMMENT] || ''} onChangeText={onChange} disabled={Boolean(loading || success)} />
      </Container>
      <Confirm title="Löschen" onClick={onRemove} width="200px" disabled={Boolean(loading || success) || !data[DELETE_REASON]} />
      {error && (
        <Message type="error" form={1} textAlign="right">
          {error}
        </Message>
      )}
    </QuestionContainer>
  );
};

DeleteSection.propTypes = { examId: PropTypes.string.isRequired };

export default DeleteSection;
